import React from 'react'
import { Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'


export default function ChangePassword() {
    const passwordReg = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*_,\\.])[0-9a-zA-Z!@#$%^&*_,\\.]{8,20}$/

    return (
        <div>
            <Form.Item
                name="newPassword"
                rules={[
                    {
                        required: true,
                        message: '请输入新密码！',
                    },
                    {
                        pattern: passwordReg,
                        message: '登录密码必须8-20位字符，且包含大小写字母、数字、特殊符号为!@#$%^&*,连续输入键盘相邻字符不能超过2位，相同字符不能连续重复超过2次！'
                    }
                ]}
                hasFeedback
            >
                <Input.Password maxLength="20" prefix={<LockOutlined className="site-form-item-icon" />} placeholder="新密码（包含大小写字母数字特殊符号）" />
            </Form.Item>
            <Form.Item
                name="newPasswordConfirm"
                dependencies={['newPassword']}
                rules={[
                    {
                    required: true,
                    message: '请输入确认新密码！',
                    },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                            return Promise.resolve();
                        }
                        return Promise.reject('您两次输入的密码不一致！');
                        },
                    }),
                ]}
                hasFeedback
            >
                <Input.Password maxLength="20" prefix={<LockOutlined className="site-form-item-icon" />} placeholder="再次确认密码" />
            </Form.Item>
        </div>
    )
}
